import { External } from '../../external';

const getDateString = (timestamp) => {
  let dateFormat = External.WebsiteSettings.getDateFormat();
  let use24HrFormat = dateFormat === 'uk';

  return (
    External.Tools.dateToStr(new Date(timestamp * 1000), dateFormat) +
    ' ' +
    External.Tools.timeToString(new Date(timestamp * 1000), use24HrFormat)
  );
};

export default getDateString;
